import {Component, HostBinding} from '@angular/core';

import {AbstractCustomPropertyView} from '../abstract-custom-property-view';

@Component({
  selector: 'ax-custom-hashed-view',
  template: `@if (value) {
      {{ value }}
    } @else {
      @for (i of [1, 2, 3, 4, 5, 6, 7, 8]; track i) {
        {{ '&bull; ' }}
      }
    }`,
})
export class CustomhashedViewComponent extends AbstractCustomPropertyView {
  @HostBinding('class.c-card__property') class = true;

  get value() {
    if (!this.property.value || this.property.value === '') {
      return undefined;
    }
    const index = this.property.value.indexOf('value=');
    if (index > 0) {
      return this.property.value.substring(index + 1, this.property.value.indexOf(';'));
    }
    return undefined;
  }
}
